import * as wjcCore from "@grapecity/wijmo"
import { e計上基準日区分, T計上基準日区分 } from "../../../constant/enum/master"
import { T海コン工程区分名称 } from "../../../constant/enum/zyutuHaisya"
import NinusiSeikyuService from "../../../service/master/ninusiseikyu/ninusiSeikyuService"
import { TTumiorosisakiListGetRes } from "../../../service/master/tumiorosisaki/TTumiorosisaki"
import { T傭車マスタ } from "../../../service/master/yosya/TYosya"
import {
  TKaikonZyutyuHaisyaKoteiGetRes,
  TKaikonZyutyuHaisyaListGetRes,
} from "../../../service/orderContainer/kaikonZyutyuHaisya/TKaikonZyutyuHaisya"
import { TKaikonZyutyuHaisyaPatternListGetRes } from "../../../service/orderContainer/kaikonZyutyuHaisyaPattern/TKaikonZyutyuHaisyaPattern"
import { TSyaryoModalList } from "../../../service/truck/TSyaryo"
import { T海コン受注配車入力GridItem } from "./KaikonZyutyuHaisyaListGrid"

/**
 * 複写ボタン用関数
 * @param item
 * @param newRowId
 * @returns
 */
export const copy = (item: TKaikonZyutyuHaisyaListGetRes, newRowId: symbol): T海コン受注配車入力GridItem => ({
  row_id: newRowId,
  新規編集フラグ: false,
  複写フラグ: 1,
  isSelected: true,
  受注配車ID: 0,
  受注伝票番号: item.受注伝票番号,
  受注枝番: item.受注枝番,
  荷主ID: item.荷主ID,
  荷主コード: item.荷主コード,
  荷主名: item.荷主名,
  荷主請求ID: item.荷主請求ID,
  表紙名: item.表紙名,
  受注配車区分ID: item.受注配車区分ID,
  荷主依頼番号: item.荷主依頼番号,
  コンテナNO: item.コンテナNO,
  コンテナサイズコード: item.コンテナサイズコード,
  コンテナ軸コード: item.コンテナ軸コード,
  船社: item.船社,
  BLBK: item.BLBK,
  本船名: item.本船名,
  VOY: item.VOY,
  オーダー内容: item.オーダー内容,
  オーダー備考: item.オーダー備考,
  オーダー指定時間: item.オーダー指定時間,
  繰返運行数: item.繰返運行数,
  配送順: item.配送順,
  輸送備考: item.輸送備考,
  コース編集: item.コース編集,
  配車状態区分コード: item.配車状態区分コード,
  受注部所コード: item.受注部所コード,
  運行部所コード: item.運行部所コード,
  運行部所名: item.運行部所名,
  付替区分ID: item.付替区分ID,
  付替区分コード: item.付替区分コード,
  支払先ID: item.支払先ID,
  支払先コード: item.支払先コード,
  傭車フラグ: item.傭車フラグ,
  傭車会社名: item.傭車会社名,
  PICK作業日: item.PICK作業日,
  PICK作業時間: item.PICK作業時間,
  PICK積卸先ID: item.PICK積卸先ID,
  PICK積卸先コード: item.PICK積卸先コード,
  PICK積卸先名称: item.PICK積卸先名称,
  PICK積卸先都道府県: item.PICK積卸先都道府県,
  PICK積卸先市区町村: item.PICK積卸先市区町村,
  PICK運行部所ID: item.PICK運行部所ID,
  PICK運行部所コード: item.PICK運行部所コード,
  PICK運行部所名: item.PICK運行部所名,
  PICK車輌ID: item.PICK車輌ID,
  PICK車番: item.PICK車番,
  PICKトレーラ車輌ID: item.PICKトレーラ車輌ID,
  PICKトレーラ車番: item.PICKトレーラ車番,
  PICK乗務員売上額: item.PICK乗務員売上額,
  PICK海コン付帯高速料: item.PICK海コン付帯高速料,
  PICK傭車フラグ: item.PICK傭車フラグ,
  PICK乗務員ID: item.PICK乗務員ID,
  PICK乗務員名: item.PICK乗務員名,
  PICK同乗者ID: item.PICK同乗者ID,
  PICK同乗者名: item.PICK同乗者名,
  PICK乗務員食事手当: item.PICK乗務員食事手当,
  PICK付帯作業手当: item.PICK付帯作業手当,
  PICK付帯作業区分コード: item.PICK付帯作業区分コード,
  PICK工程備考: item.PICK工程備考,
  作業作業日: item.作業作業日,
  作業作業時間: item.作業作業時間,
  作業積卸先ID: item.作業積卸先ID,
  作業積卸先コード: item.作業積卸先コード,
  作業積卸先名称: item.作業積卸先名称,
  作業積卸先都道府県: item.作業積卸先都道府県,
  作業積卸先市区町村: item.作業積卸先市区町村,
  作業運行部所ID: item.作業運行部所ID,
  作業運行部所コード: item.作業運行部所コード,
  作業運行部所名: item.作業運行部所名,
  作業車輌ID: item.作業車輌ID,
  作業車番: item.作業車番,
  作業トレーラ車輌ID: item.作業トレーラ車輌ID,
  作業トレーラ車番: item.作業トレーラ車番,
  作業乗務員売上額: item.作業乗務員売上額,
  作業海コン付帯高速料: item.作業海コン付帯高速料,
  作業傭車フラグ: item.作業傭車フラグ,
  作業乗務員ID: item.作業乗務員ID,
  作業乗務員名: item.作業乗務員名,
  作業同乗者ID: item.作業同乗者ID,
  作業同乗者名: item.作業同乗者名,
  作業乗務員食事手当: item.作業乗務員食事手当,
  作業付帯作業区分コード: item.作業付帯作業区分コード,
  海コン付帯作業区分ID: item.海コン付帯作業区分ID,
  付帯作業区分名称1: item.付帯作業区分名称1,
  作業付帯作業手当: item.作業付帯作業手当,
  作業内容: item.作業内容,
  作業工程備考: item.作業工程備考,
  返却作業日: item.返却作業日,
  返却作業時間: item.返却作業時間,
  返却積卸先ID: item.返却積卸先ID,
  返却積卸先コード: item.返却積卸先コード,
  返却積卸先名称: item.返却積卸先名称,
  返却積卸先都道府県: item.返却積卸先都道府県,
  返却積卸先市区町村: item.返却積卸先市区町村,
  返却運行部所ID: item.返却運行部所ID,
  返却運行部所コード: item.返却運行部所コード,
  返却運行部所名: item.返却運行部所名,
  返却車輌ID: item.返却車輌ID,
  返却車番: item.返却車番,
  返却トレーラ車輌ID: item.返却トレーラ車輌ID,
  返却トレーラ車番: item.返却トレーラ車番,
  返却乗務員売上額: item.返却乗務員売上額,
  返却海コン付帯高速料: item.返却海コン付帯高速料,
  返却傭車フラグ: item.返却傭車フラグ,
  返却乗務員ID: item.返却乗務員ID,
  返却乗務員名: item.返却乗務員名,
  返却同乗者ID: item.返却同乗者ID,
  返却同乗者名: item.返却同乗者名,
  返却乗務員食事手当: item.返却乗務員食事手当,
  返却付帯作業区分ID: item.返却付帯作業区分ID,
  返却付帯作業区分コード: item.返却付帯作業区分コード,
  返却付帯作業区分名称1: item.返却付帯作業区分名称1,
  返却付帯作業手当: item.返却付帯作業手当,
  返却工程備考: item.返却工程備考,
  その他作業日: item.その他作業日,
  その他作業時間: item.その他作業時間,
  その他積卸先ID: item.その他積卸先ID,
  その他積卸先コード: item.その他積卸先コード,
  その他積卸先名称: item.その他積卸先名称,
  その他積卸先都道府県: item.その他積卸先都道府県,
  その他積卸先市区町村: item.その他積卸先市区町村,
  その他運行部所ID: item.その他運行部所ID,
  その他運行部所コード: item.その他運行部所コード,
  その他運行部所名: item.その他運行部所名,
  その他車輌ID: item.その他車輌ID,
  その他車番: item.その他車番,
  その他トレーラ車輌ID: item.その他トレーラ車輌ID,
  その他トレーラ車番: item.その他トレーラ車番,
  その他乗務員売上額: item.その他乗務員売上額,
  その他海コン付帯高速料: item.その他海コン付帯高速料,
  その他傭車フラグ: item.その他傭車フラグ,
  その他乗務員ID: item.その他乗務員ID,
  その他乗務員名: item.その他乗務員名,
  その他同乗者ID: item.その他同乗者ID,
  その他同乗者名: item.その他同乗者名,
  その他乗務員食事手当: item.その他乗務員食事手当,
  その他付帯作業区分ID: item.その他付帯作業区分ID,
  その他付帯作業区分コード: item.その他付帯作業区分コード,
  その他付帯作業区分名称1: item.その他付帯作業区分名称1,
  その他付帯作業手当: item.その他付帯作業手当,
  その他工程備考: item.その他工程備考,
  稼働手当車種掛率区分ID: item.稼働手当車種掛率区分ID,
  乗務員ID: item.乗務員ID,
  乗務員名: item.乗務員名,
  食事手当: item.食事手当,
  稼働手当: item.稼働手当,
  特別手当: item.特別手当,
  その他手当: item.その他手当,
  荷主請求内訳ID: item.荷主請求内訳ID,
  請求内訳コード: item.請求内訳コード,
  請求内訳名: item.請求内訳名,
  請求区分ID: item.請求区分ID,
  請求車番: item.請求車番,
  請求運送料課税区分ID: item.請求運送料課税区分ID,
  請求運送料課税区分コード: item.請求運送料課税区分コード,
  請求運送料課税区分名称1: item.請求運送料課税区分名称1,
  請求運送料課税区分ソート番号: item.請求運送料課税区分ソート番号,
  請求運送料: item.請求運送料,
  請求付帯料課税区分ID: item.請求付帯料課税区分ID,
  請求付帯料課税区分コード: item.請求付帯料課税区分コード,
  請求付帯料課税区分名称1: item.請求付帯料課税区分名称1,
  請求付帯料課税区分ソート番号: item.請求付帯料課税区分ソート番号,
  請求付帯料: item.請求付帯料,
  請求高速料税込区分ID: item.請求高速料税込区分ID,
  請求高速料税込区分コード: item.請求高速料税込区分コード,
  請求高速料税込区分名称1: item.請求高速料税込区分名称1,
  請求高速料税込区分ソート番号: item.請求高速料税込区分ソート番号,
  請求高速料: item.請求高速料,
  請求処理状態区分コード: item.請求処理状態区分コード,
  請求処理状態区分名称1: item.請求処理状態区分名称1,
  計上基準日区分ID: item.計上基準日区分ID,
  計上基準日区分コード: item.計上基準日区分コード,
  計上基準日区分名称1: item.計上基準日区分名称1,
  計上基準日区分ソート番号: item.計上基準日区分ソート番号,
  請求計上日: item.請求計上日,
  請求備考: item.請求備考,
  請求額確認区分ID: item.請求額確認区分ID,
  支払運送料課税区分ID: item.支払運送料課税区分ID,
  支払運送料: item.支払運送料,
  支払付帯料課税区分ID: item.支払付帯料課税区分ID,
  支払付帯料: item.支払付帯料,
  支払高速料税込区分ID: item.支払高速料税込区分ID,
  支払高速料: item.支払高速料,
  支払計上日: item.支払計上日,
  支払備考: item.支払備考,
  支払額確認区分ID: item.支払額確認区分ID,
  乗務員売上額: item.乗務員売上額,
  受注配車パターンコード: item.受注配車パターンコード,
  bl受領書確認フラグ: item.受領書確認フラグ === 1,
})

/**
 * 選択された受注配車パターンを利用して対象行の情報を更新する
 * @param パターン
 * @param castedData
 */
export const setPattern = async (
  パターン: TKaikonZyutyuHaisyaPatternListGetRes,
  castedData: T海コン受注配車入力GridItem
) => {
  castedData.荷主ID = パターン.荷主ID
  castedData.受注配車パターンコード = パターン.受注配車パターンコード
  castedData.荷主コード = パターン.荷主コード ?? ""
  castedData.荷主名 = パターン.荷主名
  castedData.荷主請求ID = パターン.荷主請求ID
  castedData.表紙名 = パターン.表紙名
  castedData.受注配車区分ID = パターン.受注配車区分ID
  castedData.コンテナサイズコード = パターン.コンテナサイズコード
  castedData.コンテナ軸コード = パターン.コンテナ軸コード
  castedData.オーダー内容 = パターン.オーダー内容
  castedData.オーダー備考 = パターン.オーダー備考
  castedData.オーダー指定時間 = パターン.オーダー指定時間
  castedData.配車状態区分コード = パターン.配車状態区分コード
  castedData.繰返運行数 = パターン.繰返運行数
  castedData.配送順 = パターン.配送順
  castedData.輸送備考 = パターン.輸送備考
  castedData.コース編集 = パターン.コース編集
  castedData.受注部所ID = パターン.受注部所ID
  castedData.受注部所コード = パターン.受注部所コード
  castedData.受注部所名 = パターン.受注部所名
  castedData.運行部所ID = パターン.運行部所ID
  castedData.運行部所コード = パターン.運行部所コード
  castedData.運行部所名 = パターン.運行部所名
  castedData.付替区分ID = パターン.付替区分ID
  castedData.支払先ID = パターン.支払先ID
  castedData.支払先コード = パターン.支払先コード
  castedData.傭車会社名 = パターン.傭車会社名
  castedData.PICK積卸先ID = パターン.PICK積卸先ID
  castedData.PICK積卸先コード = パターン.PICK積卸先コード
  castedData.PICK積卸先名称 = パターン.PICK積卸先名称
  castedData.PICK積卸先都道府県 = パターン.PICK積卸先都道府県
  castedData.PICK積卸先市区町村 = パターン.PICK積卸先市区町村
  castedData.PICK運行部所ID = パターン.PICK運行部所ID
  castedData.PICK運行部所コード = パターン.PICK運行部所コード
  castedData.PICK車輌ID = パターン.PICK車輌ID
  castedData.PICK車番 = パターン.PICK車番
  castedData.PICKトレーラ車輌ID = パターン.PICKトレーラ車輌ID
  castedData.PICKトレーラ車番 = パターン.PICKトレーラ車番
  castedData.PICK乗務員売上額 = パターン.PICK乗務員売上額
  castedData.PICK乗務員ID = パターン.PICK乗務員ID
  castedData.PICK乗務員名 = パターン.PICK乗務員名
  castedData.PICK同乗者ID = パターン.PICK同乗者ID
  castedData.PICK同乗者名 = パターン.PICK同乗者名
  castedData.PICK付帯作業区分コード = パターン.PICK付帯作業区分コード
  castedData.PICK乗務員食事手当 = パターン.PICK乗務員食事手当
  castedData.PICK付帯作業手当 = パターン.PICK付帯作業手当
  castedData.PICK海コン付帯高速料 = パターン.PICK海コン付帯高速料
  castedData.PICK工程備考 = パターン.PICK工程備考

  castedData.作業積卸先ID = パターン.作業積卸先ID
  castedData.作業積卸先コード = パターン.作業積卸先コード
  castedData.作業積卸先名称 = パターン.作業積卸先名称
  castedData.作業積卸先都道府県 = パターン.作業積卸先都道府県
  castedData.作業積卸先市区町村 = パターン.作業積卸先市区町村
  castedData.作業運行部所ID = パターン.作業運行部所ID
  castedData.作業運行部所コード = パターン.作業運行部所コード
  castedData.作業車輌ID = パターン.作業車輌ID
  castedData.作業車番 = パターン.作業車番
  castedData.作業トレーラ車輌ID = パターン.作業トレーラ車輌ID
  castedData.作業トレーラ車番 = パターン.作業トレーラ車番
  castedData.作業乗務員売上額 = パターン.作業乗務員売上額
  castedData.作業乗務員ID = パターン.作業乗務員ID
  castedData.作業乗務員名 = パターン.作業乗務員名
  castedData.作業同乗者ID = パターン.作業同乗者ID
  castedData.作業同乗者名 = パターン.作業同乗者名
  castedData.作業乗務員食事手当 = パターン.作業乗務員食事手当
  castedData.海コン付帯作業区分ID = パターン.海コン付帯作業区分ID
  castedData.作業付帯作業区分コード = パターン.作業付帯作業区分コード
  castedData.付帯作業区分名称1 = パターン.付帯作業区分名称1
  castedData.作業付帯作業手当 = パターン.作業付帯作業手当
  castedData.作業海コン付帯高速料 = パターン.作業海コン付帯高速料
  castedData.作業工程備考 = パターン.作業工程備考

  castedData.作業内容 = パターン.作業内容
  castedData.返却積卸先ID = パターン.返却積卸先ID
  castedData.返却積卸先コード = パターン.返却積卸先コード
  castedData.返却積卸先名称 = パターン.返却積卸先名称
  castedData.返却積卸先都道府県 = パターン.返却積卸先都道府県
  castedData.返却積卸先市区町村 = パターン.返却積卸先市区町村
  castedData.返却運行部所ID = パターン.返却運行部所ID
  castedData.返却運行部所コード = パターン.返却運行部所コード
  castedData.返却車輌ID = パターン.返却車輌ID
  castedData.返却車番 = パターン.返却車番
  castedData.返却トレーラ車輌ID = パターン.返却トレーラ車輌ID
  castedData.返却トレーラ車番 = パターン.返却トレーラ車番
  castedData.返却乗務員売上額 = パターン.返却乗務員売上額
  castedData.返却乗務員ID = パターン.返却乗務員ID
  castedData.返却乗務員名 = パターン.返却乗務員名
  castedData.返却同乗者ID = パターン.返却同乗者ID
  castedData.返却同乗者名 = パターン.返却同乗者名
  castedData.返却乗務員食事手当 = パターン.返却乗務員食事手当
  castedData.返却付帯作業区分ID = パターン.返却付帯作業区分ID
  castedData.返却付帯作業区分コード = パターン.返却付帯作業区分コード
  castedData.返却付帯作業区分名称1 = パターン.返却付帯作業区分名称1
  castedData.返却付帯作業手当 = パターン.返却付帯作業手当
  castedData.返却海コン付帯高速料 = パターン.返却海コン付帯高速料
  castedData.返却工程備考 = パターン.返却工程備考

  castedData.その他積卸先ID = パターン.その他積卸先ID
  castedData.その他積卸先コード = パターン.その他積卸先コード
  castedData.その他積卸先名称 = パターン.その他積卸先名称
  castedData.その他積卸先都道府県 = パターン.その他積卸先都道府県
  castedData.その他積卸先市区町村 = パターン.その他積卸先市区町村
  castedData.その他運行部所ID = パターン.その他運行部所ID
  castedData.その他運行部所コード = パターン.その他運行部所コード
  castedData.その他車輌ID = パターン.その他車輌ID
  castedData.その他車番 = パターン.その他車番
  castedData.その他トレーラ車輌ID = パターン.その他トレーラ車輌ID
  castedData.その他トレーラ車番 = パターン.その他トレーラ車番
  castedData.その他乗務員売上額 = パターン.その他乗務員売上額
  castedData.その他乗務員ID = パターン.その他乗務員ID
  castedData.その他乗務員名 = パターン.その他乗務員名
  castedData.その他同乗者ID = パターン.その他同乗者ID
  castedData.その他同乗者名 = パターン.その他同乗者名
  castedData.その他乗務員食事手当 = パターン.その他乗務員食事手当
  castedData.その他付帯作業区分ID = パターン.その他付帯作業区分ID
  castedData.その他付帯作業区分コード = パターン.その他付帯作業区分コード
  castedData.その他付帯作業区分名称1 = パターン.その他付帯作業区分名称1
  castedData.その他付帯作業手当 = パターン.その他付帯作業手当
  castedData.その他海コン付帯高速料 = パターン.その他海コン付帯高速料
  castedData.その他工程備考 = パターン.その他工程備考

  castedData.稼働手当車種掛率区分ID = パターン.稼働手当車種掛率区分ID
  castedData.乗務員ID = パターン.乗務員ID
  castedData.乗務員名 = パターン.乗務員名
  castedData.同乗者乗務員ID = パターン.同乗者1乗務員ID
  castedData.同乗者名 = パターン.同乗者1名
  castedData.同乗者場所区分ID = パターン.同乗者1場所区分ID
  castedData.食事手当 = パターン.食事手当
  castedData.稼働手当 = パターン.稼働手当
  castedData.特別手当 = パターン.特別手当
  castedData.その他手当 = パターン.その他手当
  castedData.荷主請求内訳ID = パターン.荷主請求内訳ID
  castedData.請求内訳コード = パターン.請求内訳コード
  castedData.請求車番 = パターン.請求車番
  castedData.請求内訳名 = パターン.請求内訳名
  castedData.請求区分ID = パターン.請求区分ID
  castedData.計上基準日区分コード = パターン.計上基準日区分コード
  castedData.計上基準日区分ID = パターン.計上基準日区分ID
  castedData.計上基準日区分名称1 = パターン.計上基準日区分名称1
  castedData.請求運送料課税区分ID = パターン.請求運送料課税区分ID
  castedData.請求運送料課税区分コード = パターン.請求運送料課税区分コード
  castedData.請求運送料課税区分名称1 = パターン.請求運送料課税区分名称1
  castedData.請求運送料 = パターン.請求運送料
  castedData.請求付帯料課税区分ID = パターン.請求付帯料課税区分ID
  castedData.請求付帯料課税区分コード = パターン.請求付帯料課税区分コード
  castedData.請求付帯料課税区分名称1 = パターン.請求付帯料課税区分名称1
  castedData.請求付帯料 = パターン.請求付帯料
  castedData.請求高速料税込区分ID = パターン.請求高速料税込区分ID
  castedData.請求高速料税込区分コード = パターン.請求高速料税込区分コード
  castedData.請求高速料税込区分名称1 = パターン.請求高速料税込区分名称1
  castedData.請求高速料 = パターン.請求高速料
  castedData.請求備考 = パターン.請求備考
  castedData.支払運送料課税区分ID = パターン.支払運送料課税区分ID
  castedData.支払運送料 = パターン.支払運送料
  castedData.支払付帯料課税区分ID = パターン.支払付帯料課税区分ID
  castedData.支払付帯料 = パターン.支払付帯料
  castedData.支払高速料税込区分ID = パターン.支払高速料税込区分ID
  castedData.支払高速料 = パターン.支払高速料
  castedData.支払備考 = パターン.支払備考

  // 高速料税込区分は最新の荷主請求IDより取得し登録する
  if (パターン.荷主請求ID != null) {
    try {
      const 荷主請求Res = await new NinusiSeikyuService().get(パターン.荷主請求ID)
      if (荷主請求Res && 荷主請求Res.data) {
        castedData.請求高速料税込区分コード = 荷主請求Res.data.高速料税込区分コード
        castedData.請求高速料税込区分名称1 = 荷主請求Res.data.高速料税込区分名称1
      }
    } catch (error) {}
  } else {
    castedData.請求高速料税込区分コード = ""
    castedData.請求高速料税込区分名称1 = ""
  }

  // パターンの計上基準日区分が空のとき荷主請求内訳IDで検索して取得しなおす
  if (パターン.計上基準日区分コード != null && パターン.計上基準日区分コード !== "") {
    castedData.計上基準日区分コード = パターン.計上基準日区分コード
    castedData.計上基準日区分名称1 = パターン.計上基準日区分名称1
  } else if (パターン.荷主請求内訳ID != null) {
    try {
      const 請求内訳res = await new NinusiSeikyuService().getListUchiwake({
        荷主請求内訳Id: パターン.荷主請求内訳ID,
      })
      if (請求内訳res && 請求内訳res.data.length > 0) {
        castedData.計上基準日区分コード = 請求内訳res.data[0].計上基準日区分コード
        castedData.計上基準日区分名称1 = 請求内訳res.data[0].計上基準日区分名称1

        // 計上基準日区分で請求計上日を設定する
        switch (castedData.計上基準日区分コード as T計上基準日区分) {
          case e計上基準日区分.PICK日:
            castedData.請求計上日 = castedData.PICK作業日
            break
          case e計上基準日区分.作業日:
            castedData.請求計上日 = castedData.作業作業日
            break
          case e計上基準日区分.返却日:
            castedData.請求計上日 = castedData.返却作業日
            break
          default:
            break
        }
      }
    } catch (error) {}
  }

  // 計上基準日区分で請求計上日を設定する
  switch (castedData.計上基準日区分コード as T計上基準日区分) {
    case e計上基準日区分.PICK日:
      castedData.請求計上日 = castedData.PICK作業日
      break
    case e計上基準日区分.作業日:
      castedData.請求計上日 = castedData.作業作業日
      break
    case e計上基準日区分.返却日:
      castedData.請求計上日 = castedData.返却作業日
      break
    default:
      break
  }
}

/**
 * 車輌の情報をキャストします
 */
export const castヘッド車輌 = (
  rowItem: T海コン受注配車入力GridItem,
  車輌: TSyaryoModalList | null | undefined,
  工程: T海コン工程区分名称
) => {
  if (車輌) {
    switch (工程) {
      case "PICK":
        rowItem.PICK車輌ID = 車輌.車輌ID
        rowItem.PICK車番 = 車輌.車番
        if (車輌.社員ID != null) {
          rowItem.PICK乗務員ID = 車輌.乗務員ID
          rowItem.PICK乗務員名 = 車輌.社員氏名
        }
        if (車輌.トレーラ車輌ID != null) {
          rowItem.PICKトレーラ車輌ID = 車輌.トレーラ車輌ID
          rowItem.PICKトレーラ車番 = 車輌.トレーラ車番
        }
        break
      case "作業":
        rowItem.作業車輌ID = 車輌.車輌ID
        rowItem.作業車番 = 車輌.車番
        if (車輌.社員ID != null) {
          rowItem.作業乗務員ID = 車輌.乗務員ID
          rowItem.作業乗務員名 = 車輌.社員氏名
        }
        if (車輌.トレーラ車輌ID != null) {
          rowItem.作業トレーラ車輌ID = 車輌.トレーラ車輌ID
          rowItem.作業トレーラ車番 = 車輌.トレーラ車番
        }
        break
      case "返却":
        rowItem.返却車輌ID = 車輌.車輌ID
        rowItem.返却車番 = 車輌.車番
        if (車輌.社員ID != null) {
          rowItem.返却乗務員ID = 車輌.乗務員ID
          rowItem.返却乗務員名 = 車輌.社員氏名
        }
        if (車輌.トレーラ車輌ID != null) {
          rowItem.返却トレーラ車輌ID = 車輌.トレーラ車輌ID
          rowItem.返却トレーラ車番 = 車輌.トレーラ車番
        }
        break
      case "その他":
        rowItem.その他車輌ID = 車輌.車輌ID
        rowItem.その他車番 = 車輌.車番
        if (車輌.社員ID != null) {
          rowItem.その他乗務員ID = 車輌.乗務員ID
          rowItem.その他乗務員名 = 車輌.社員氏名
        }
        if (車輌.トレーラ車輌ID != null) {
          rowItem.その他トレーラ車輌ID = 車輌.トレーラ車輌ID
          rowItem.その他トレーラ車番 = 車輌.トレーラ車番
        }
        break
      default:
        break
    }
  } else {
    // データは削除する
    switch (工程) {
      case "PICK":
        rowItem.PICK車輌ID = undefined
        rowItem.PICK車番 = undefined
        break
      case "作業":
        rowItem.作業車輌ID = undefined
        rowItem.作業車番 = undefined
        break
      case "返却":
        rowItem.返却車輌ID = undefined
        rowItem.返却車番 = undefined
        break
      case "その他":
        rowItem.その他車輌ID = undefined
        rowItem.その他車番 = undefined
        break
    }
  }
  rowItem.請求車番 = rowItem.作業車番 ?? rowItem.その他車番 ?? rowItem.返却車番 ?? rowItem.PICK車番 ?? undefined
}

/**
 * 車輌の情報を傭車でキャストします
 */
export const castヘッド傭車 = (
  rowItem: T海コン受注配車入力GridItem,
  傭車: T傭車マスタ | null | undefined,
  工程: T海コン工程区分名称
) => {
  if (傭車) {
    switch (工程) {
      case "PICK":
        rowItem.PICK車輌ID = undefined
        rowItem.PICK車番 = 傭車.車番
        if (!wjcCore.isNullOrWhiteSpace(傭車.乗務員名 ?? "")) {
          rowItem.PICK乗務員ID = undefined
          rowItem.PICK乗務員名 = 傭車.乗務員名
        }
        break
      case "作業":
        rowItem.作業車輌ID = undefined
        rowItem.作業車番 = 傭車.車番
        if (!wjcCore.isNullOrWhiteSpace(傭車.乗務員名 ?? "")) {
          rowItem.作業乗務員ID = undefined
          rowItem.作業乗務員名 = 傭車.乗務員名
        }
        break
      case "返却":
        rowItem.返却車輌ID = undefined
        rowItem.返却車番 = 傭車.車番
        if (!wjcCore.isNullOrWhiteSpace(傭車.乗務員名 ?? "")) {
          rowItem.返却乗務員ID = undefined
          rowItem.返却乗務員名 = 傭車.乗務員名
        }
        break
      case "その他":
        rowItem.その他車輌ID = undefined
        rowItem.その他車番 = 傭車.車番
        if (!wjcCore.isNullOrWhiteSpace(傭車.乗務員名 ?? "")) {
          rowItem.その他乗務員ID = undefined
          rowItem.その他乗務員名 = 傭車.乗務員名
        }
        break
      default:
        break
    }
  } else {
    const 車輌IDPropertyName = `${工程}車輌ID` as keyof Pick<
      T海コン受注配車入力GridItem,
      "PICK車輌ID" | "作業車輌ID" | "返却車輌ID" | "その他車輌ID"
    >
    const 乗務員名PropertyName = `${工程}乗務員名` as keyof Pick<
      T海コン受注配車入力GridItem,
      "PICK乗務員名" | "作業乗務員名" | "返却乗務員名" | "その他乗務員名"
    >

    rowItem[車輌IDPropertyName] = undefined
    rowItem[乗務員名PropertyName] = undefined
  }
  rowItem.請求車番 = rowItem.作業車番 ?? rowItem.その他車番 ?? rowItem.返却車番 ?? rowItem.PICK車番 ?? undefined
}

/**
 * トレーラ車輌の情報をキャストします
 */
export const castトレーラ車輌 = (
  rowItem: T海コン受注配車入力GridItem,
  車輌: TSyaryoModalList | null | undefined,
  工程: T海コン工程区分名称
) => {
  if (車輌) {
    switch (工程) {
      case "PICK":
        rowItem.PICKトレーラ車輌ID = 車輌.車輌ID
        rowItem.PICKトレーラ車番 = 車輌.車番
        break
      case "作業":
        rowItem.作業トレーラ車輌ID = 車輌.車輌ID
        rowItem.作業トレーラ車番 = 車輌.車番
        break
      case "返却":
        rowItem.返却トレーラ車輌ID = 車輌.車輌ID
        rowItem.返却トレーラ車番 = 車輌.車番

        break
      case "その他":
        rowItem.その他トレーラ車輌ID = 車輌.車輌ID
        rowItem.その他トレーラ車番 = 車輌.車番
        break
      default:
        break
    }
  } else {
    // データは削除する
    switch (工程) {
      case "PICK":
        rowItem.PICKトレーラ車輌ID = undefined
        rowItem.PICKトレーラ車番 = undefined
        break
      case "作業":
        rowItem.作業トレーラ車輌ID = undefined
        rowItem.作業トレーラ車番 = undefined
        break
      case "返却":
        rowItem.返却トレーラ車輌ID = undefined
        rowItem.返却トレーラ車番 = undefined
        break
      case "その他":
        rowItem.その他トレーラ車輌ID = undefined
        rowItem.その他トレーラ車番 = undefined
        break
    }
  }
}

/**
 * トレーラ車輌の情報を傭車でキャストします
 */
export const castトレーラ傭車 = (
  rowItem: T海コン受注配車入力GridItem,
  傭車: T傭車マスタ | null | undefined,
  工程: T海コン工程区分名称
) => {
  if (傭車) {
    switch (工程) {
      case "PICK":
        rowItem.PICKトレーラ車輌ID = undefined
        rowItem.PICKトレーラ車番 = 傭車.車番
        break
      case "作業":
        rowItem.作業トレーラ車輌ID = undefined
        rowItem.作業トレーラ車番 = 傭車.車番
        break
      case "返却":
        rowItem.返却トレーラ車輌ID = undefined
        rowItem.返却トレーラ車番 = 傭車.車番

        break
      case "その他":
        rowItem.その他トレーラ車輌ID = undefined
        rowItem.その他トレーラ車番 = 傭車.車番
        break
      default:
        break
    }
  } else {
    // 未選択の場合でも、傭車は自由入力のため車番のみ保持する
    switch (工程) {
      case "PICK":
        rowItem.PICKトレーラ車輌ID = undefined
        break
      case "作業":
        rowItem.作業トレーラ車輌ID = undefined
        break
      case "返却":
        rowItem.返却トレーラ車輌ID = undefined
        break
      case "その他":
        rowItem.その他トレーラ車輌ID = undefined
        break
    }
  }
}

/**
 * 積卸先の情報をキャストします
 */
export const cast積卸先 = (
  rowItem: T海コン受注配車入力GridItem,
  積卸先: TTumiorosisakiListGetRes | null | undefined,
  工程: T海コン工程区分名称
) => {
  switch (工程) {
    case "PICK":
      if (積卸先) {
        rowItem.PICK積卸先ID = 積卸先.積卸先ID
        rowItem.PICK積卸先コード = 積卸先.積卸先コード
        rowItem.PICK積卸先名称 = 積卸先.積卸先略称
        rowItem.PICK積卸先都道府県 = 積卸先.住所１ ?? ""
        rowItem.PICK積卸先市区町村 = 積卸先.住所２ ?? ""
      } else {
        rowItem.PICK積卸先ID = undefined
        rowItem.PICK積卸先コード = undefined
        rowItem.PICK積卸先名称 = undefined
        rowItem.PICK積卸先都道府県 = undefined
        rowItem.PICK積卸先市区町村 = undefined
      }
      break
    case "作業":
      if (積卸先) {
        rowItem.作業積卸先ID = 積卸先.積卸先ID
        rowItem.作業積卸先コード = 積卸先.積卸先コード
        rowItem.作業積卸先名称 = 積卸先.積卸先略称
        rowItem.作業積卸先都道府県 = 積卸先.住所１ ?? ""
        rowItem.作業積卸先市区町村 = 積卸先.住所２ ?? ""
      } else {
        rowItem.作業積卸先ID = undefined
        rowItem.作業積卸先コード = undefined
        rowItem.作業積卸先名称 = undefined
        rowItem.作業積卸先都道府県 = undefined
        rowItem.作業積卸先市区町村 = undefined
      }
      break
    case "返却":
      if (積卸先) {
        rowItem.返却積卸先ID = 積卸先.積卸先ID
        rowItem.返却積卸先コード = 積卸先.積卸先コード
        rowItem.返却積卸先名称 = 積卸先.積卸先略称
        rowItem.返却積卸先都道府県 = 積卸先.住所１ ?? ""
        rowItem.返却積卸先市区町村 = 積卸先.住所２ ?? ""
      } else {
        rowItem.返却積卸先ID = undefined
        rowItem.返却積卸先コード = undefined
        rowItem.返却積卸先名称 = undefined
        rowItem.返却積卸先都道府県 = undefined
        rowItem.返却積卸先市区町村 = undefined
      }
      break
    case "その他":
      if (積卸先) {
        rowItem.その他積卸先ID = 積卸先.積卸先ID
        rowItem.その他積卸先コード = 積卸先.積卸先コード
        rowItem.その他積卸先名称 = 積卸先.積卸先略称
        rowItem.その他積卸先都道府県 = 積卸先.住所１ ?? ""
        rowItem.その他積卸先市区町村 = 積卸先.住所２ ?? ""
      } else {
        rowItem.その他積卸先ID = undefined
        rowItem.その他積卸先コード = undefined
        rowItem.その他積卸先名称 = undefined
        rowItem.その他積卸先都道府県 = undefined
        rowItem.その他積卸先市区町村 = undefined
      }
      break
    default:
      break
  }
}

/**
 * 乗務員の情報をキャストします
 */
export const cast乗務員 = (
  rowItem: T海コン受注配車入力GridItem,
  乗務員:
    | {
        乗務員ID?: number
        社員氏名?: string
      }
    | null
    | undefined,
  乗務員種別: "乗務員" | "同乗者",
  工程: T海コン工程区分名称
) => {
  if (乗務員) {
    switch (工程) {
      case "PICK":
        if (乗務員種別 === "乗務員") {
          rowItem.PICK乗務員ID = 乗務員.乗務員ID
          rowItem.PICK乗務員名 = 乗務員.社員氏名
        } else {
          rowItem.PICK同乗者ID = 乗務員.乗務員ID
          rowItem.PICK同乗者名 = 乗務員.社員氏名
        }
        break
      case "作業":
        if (乗務員種別 === "乗務員") {
          rowItem.作業乗務員ID = 乗務員.乗務員ID
          rowItem.作業乗務員名 = 乗務員.社員氏名
        } else {
          rowItem.作業同乗者ID = 乗務員.乗務員ID
          rowItem.作業同乗者名 = 乗務員.社員氏名
        }
        break
      case "返却":
        if (乗務員種別 === "乗務員") {
          rowItem.返却乗務員ID = 乗務員.乗務員ID
          rowItem.返却乗務員名 = 乗務員.社員氏名
        } else {
          rowItem.返却同乗者ID = 乗務員.乗務員ID
          rowItem.返却同乗者名 = 乗務員.社員氏名
        }
        break
      case "その他":
        if (乗務員種別 === "乗務員") {
          rowItem.その他乗務員ID = 乗務員.乗務員ID
          rowItem.その他乗務員名 = 乗務員.社員氏名
        } else {
          rowItem.その他同乗者ID = 乗務員.乗務員ID
          rowItem.その他同乗者名 = 乗務員.社員氏名
        }
        break
      default:
        break
    }
  } else {
    switch (工程) {
      case "PICK":
        if (乗務員種別 === "乗務員") {
          rowItem.PICK乗務員ID = undefined
          rowItem.PICK乗務員名 = undefined
        } else {
          rowItem.PICK同乗者ID = undefined
          rowItem.PICK同乗者名 = undefined
        }
        break
      case "作業":
        if (乗務員種別 === "乗務員") {
          rowItem.作業乗務員ID = undefined
          rowItem.作業乗務員名 = undefined
        } else {
          rowItem.作業同乗者ID = undefined
          rowItem.作業同乗者名 = undefined
        }
        break
      case "返却":
        if (乗務員種別 === "乗務員") {
          rowItem.返却乗務員ID = undefined
          rowItem.返却乗務員名 = undefined
        } else {
          rowItem.返却同乗者ID = undefined
          rowItem.返却同乗者名 = undefined
        }
        break
      case "その他":
        if (乗務員種別 === "乗務員") {
          rowItem.その他乗務員ID = undefined
          rowItem.その他乗務員名 = undefined
        } else {
          rowItem.その他同乗者ID = undefined
          rowItem.その他同乗者名 = undefined
        }
        break
      default:
        break
    }
  }
}

export const clear運行情報 = (castedData: T海コン受注配車入力GridItem, 工程: T海コン工程区分名称) => {
  switch (工程) {
    case "PICK":
      castedData.PICK車輌ID = undefined
      castedData.PICK車番 = undefined
      castedData.PICKトレーラ車輌ID = undefined
      castedData.PICKトレーラ車番 = undefined
      castedData.PICK乗務員ID = undefined
      castedData.PICK乗務員名 = undefined
      castedData.PICK同乗者ID = undefined
      castedData.PICK同乗者名 = undefined
      castedData.PICK乗務員売上額 = undefined
      castedData.PICK付帯作業区分コード = undefined
      castedData.PICK乗務員食事手当 = undefined
      break
    case "作業":
      castedData.作業車輌ID = undefined
      castedData.作業車番 = undefined
      castedData.作業トレーラ車輌ID = undefined
      castedData.作業トレーラ車番 = undefined
      castedData.作業乗務員ID = undefined
      castedData.作業乗務員名 = undefined
      castedData.作業同乗者ID = undefined
      castedData.作業同乗者名 = undefined
      castedData.作業乗務員売上額 = undefined
      castedData.作業付帯作業区分コード = undefined
      castedData.作業乗務員食事手当 = undefined
      break
    case "返却":
      castedData.返却車輌ID = undefined
      castedData.返却車番 = undefined
      castedData.返却トレーラ車輌ID = undefined
      castedData.返却トレーラ車番 = undefined
      castedData.返却乗務員ID = undefined
      castedData.返却乗務員名 = undefined
      castedData.返却同乗者ID = undefined
      castedData.返却同乗者名 = undefined
      castedData.返却乗務員売上額 = undefined
      castedData.返却付帯作業区分コード = undefined
      castedData.返却乗務員食事手当 = undefined
      break
    case "その他":
      castedData.その他車輌ID = undefined
      castedData.その他車番 = undefined
      castedData.その他トレーラ車輌ID = undefined
      castedData.その他トレーラ車番 = undefined
      castedData.その他乗務員ID = undefined
      castedData.その他乗務員名 = undefined
      castedData.その他同乗者ID = undefined
      castedData.その他同乗者名 = undefined
      castedData.その他乗務員売上額 = undefined
      castedData.その他付帯作業区分コード = undefined
      castedData.その他乗務員食事手当 = undefined
      break
    default:
      break
  }
}

export type T海コンコース情報加工用工程情報 = {
  PICK情報: TKaikonZyutyuHaisyaKoteiGetRes | null | undefined
  作業情報: TKaikonZyutyuHaisyaKoteiGetRes | null | undefined
  返却情報: TKaikonZyutyuHaisyaKoteiGetRes | null | undefined
  その他情報: TKaikonZyutyuHaisyaKoteiGetRes | null | undefined
}

const 積卸情報存在チェック = (工程情報: TKaikonZyutyuHaisyaKoteiGetRes | null | undefined) => {
  return (
    工程情報 != null &&
    !(
      wjcCore.isNullOrWhiteSpace(工程情報.積卸先名 ?? "") &&
      wjcCore.isNullOrWhiteSpace(工程情報.積卸先市区町村 ?? "") &&
      wjcCore.isNullOrWhiteSpace(工程情報.積卸先都道府県 ?? "")
    )
  )
}

export const createコース編集 = (工程情報: T海コンコース情報加工用工程情報) => {
  let コース編集Text = ""

  // 工程区分の存在を0,1でフラグ化(1の時存在)
  // PICK | 作業 | 返却 | その他
  const 工程存在フラグ = `${積卸情報存在チェック(工程情報?.PICK情報) ? 1 : 0}${
    積卸情報存在チェック(工程情報?.作業情報) ? 1 : 0
  }${積卸情報存在チェック(工程情報?.返却情報) ? 1 : 0}${積卸情報存在チェック(工程情報?.その他情報) ? 1 : 0}`

  const PICKText = `${工程情報?.PICK情報?.積卸先名 ?? ""}`

  const 作業Text = `${工程情報?.作業情報?.積卸先名 ?? ""}${工程情報?.作業情報?.積卸先名 ? "/" : ""}${
    工程情報?.作業情報?.積卸先市区町村 ?? ""
  }`

  const 返却Text = `${工程情報?.返却情報?.積卸先名 ?? ""}`

  const その他Text = `${工程情報?.その他情報?.積卸先名 ?? ""}${工程情報?.その他情報?.積卸先名 ? "/" : ""}${
    工程情報?.その他情報?.積卸先市区町村 ?? ""
  }`

  switch (工程存在フラグ) {
    //PICKと作業が存在する場合、返却とその他を省略する
    case "1111":
    case "1110":
    case "1101":
    case "1100":
      //【PICK】社名（ヤード）～　【作業】社名（ヤード）/市区町村（住所２）
      コース編集Text = `${PICKText}${wjcCore.isNullOrWhiteSpace(PICKText) ? `` : `～ `}${作業Text}`
      break
    //PICKと返却が存在する場合、その他を省略する
    case "1011":
    case "1010":
      //【PICK】社名（ヤード）～　【返却】社名（ヤード）
      コース編集Text = `${PICKText}${wjcCore.isNullOrWhiteSpace(PICKText) ? `` : `～ `}${返却Text}`
      break
    //PICKが存在する場合、その他は省略する
    case "1000":
    case "1001":
      //【PICK】社名（ヤード）
      コース編集Text = `${PICKText}`
      break
    //作業が存在する場合、その他を省略する。
    case "0111":
    case "0110":
      //【作業】社名（ヤード）/市区町村（住所２）～　【返却】社名（ヤード）
      コース編集Text = `${作業Text}${wjcCore.isNullOrWhiteSpace(作業Text) ? `` : `～ `}${返却Text}`
      break
    case "0101":
    case "0100":
      //【作業】社名（ヤード）/市区町村（住所２）
      コース編集Text = `${作業Text}`
      break
    case "0011":
    case "0010":
      //【返却】社名（ヤード）
      コース編集Text = `${返却Text}`
      break
    case "0001":
      //【その他】社名（ヤード）/市区町村（住所２）
      コース編集Text = `${その他Text}`
      break
    default:
      //上記のパターンに当てはまらない際は以前のロジックを適用
      if (工程情報?.PICK情報) {
        コース編集Text += PICKText
      }
      if (工程情報?.作業情報) {
        if (wjcCore.isNullOrWhiteSpace(コース編集Text)) {
          コース編集Text += 作業Text
        } else {
          コース編集Text += wjcCore.isNullOrWhiteSpace(作業Text) ? "" : "～ " + 作業Text
        }
      }
      if (工程情報?.返却情報) {
        if (wjcCore.isNullOrWhiteSpace(コース編集Text)) {
          コース編集Text += 返却Text
        } else {
          コース編集Text += wjcCore.isNullOrWhiteSpace(返却Text) ? " " : "～ " + 返却Text
        }
      }
      if (工程情報?.その他情報) {
        if (wjcCore.isNullOrWhiteSpace(コース編集Text)) {
          コース編集Text += その他Text
        } else {
          コース編集Text += wjcCore.isNullOrWhiteSpace(その他Text) ? " " : ", " + その他Text
        }
      }
      break
  }

  return コース編集Text
}
